import { render, staticRenderFns } from "./DismissOnboardingButton.vue?vue&type=template&id=07382125&scoped=true&"
import script from "./DismissOnboardingButton.vue?vue&type=script&lang=js&"
export * from "./DismissOnboardingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07382125",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
